import createMuiTheme from "@material-ui/core/styles/createTheme";
import { base } from "./base";
export var light = createMuiTheme(Object.assign(Object.assign({}, base), {
    name: "light",
    palette: Object.assign(Object.assign({}, base.palette), {
        primary: {
            light: "#D6EFF9",
            main: "#269AE0",
            dark: "#157DBB"
        }
    })
}));
